import Bloc from './Bloc.js';
import Types from './Types.js';

export default class LoseIntent extends Bloc {

	constructor (src, ctx) {

		super("loseintent", src, ctx, true);
		this.f = (src, ins) => {
			if (ins[0].id && ins[0].id.type === "enemy")
				ins[0].loseIntent();
			return [];
		};
		this.types = [Types.entity];
	}
}